import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <nav className="flex h-16 items-center justify-between px-4 md:h-20 md:px-8">
        <a href="#home" onClick={closeMenu} className="flex items-center gap-2">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-vip-crown-2-line text-lg" />
          </span>
          <span
            className={`font-heading text-lg font-bold ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            妖精视频
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className={`rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  scrolled
                    ? "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                    : "text-background-100 hover:bg-background-50/15 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className={`hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors md:inline-flex ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-foreground-900 hover:bg-background-100"
            }`}
          >
            订阅更新
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={open}
            className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden ${
              scrolled ? "text-foreground-900" : "text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </nav>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <ul className="grid grid-cols-2 gap-1">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={closeMenu}
                  className="block rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#subscribe"
            onClick={closeMenu}
            className="mt-2 block rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
          >
            订阅更新
          </a>
        </div>
      ) : null}
    </header>
  );
}